import { render, staticRenderFns } from "./transAcctSForm.vue?vue&type=template&id=bcef1202&scoped=true&"
import script from "./transAcctSForm.vue?vue&type=script&lang=js&"
export * from "./transAcctSForm.vue?vue&type=script&lang=js&"
import style0 from "./transAcctSForm.vue?vue&type=style&index=0&id=bcef1202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcef1202",
  null
  
)

export default component.exports